import type { PricingFaqSummary } from "@/lib/catalog-faq";

function isPositivePrice(value: string | null | undefined): boolean {
  const number = Number(value);
  return Number.isFinite(number) && number > 0;
}

export function hasComparablePriceHistory(summary: PricingFaqSummary): boolean {
  if (summary.priceHistoryObservationCount < 2) return false;
  if (summary.priceHistoryCurrency !== summary.currency) return false;
  return (
    isPositivePrice(summary.priceHistoryTypical) || isPositivePrice(summary.priceHistoryAverage)
  );
}
